module.exports = __webpack_public_path__ + "img/创新的可视化操控@2x.2cb7f25b.png";